import {
  FETCH_ALL_TENANT_CONTACTS,
  FETCH_TENANT_CONTACTS,
  SET_TENANT_PAGINATION,
  SET_OWNER_PAGINATION,
  FETCH_OWNER_CONTACTS,
  UPDATE_TENANT_CONTACT,
  UPDATE_OWNER_CONTACT,
} from '../actions/types'

const defaultState = {
  allTenants: [],
  tenants: [],
  tenantsPagination: {
    page: 1,
    pageSize: 50,
    sortColumn: '',
    sortOrder: '',
    search: '',
  },
  tanantsTotalRecord: '',
  owners: [],
  ownersPagination: {
    page: 1,
    pageSize: 50,
    sortColumn: '',
    sortOrder: '',
    search: '',
  },
  ownersTotalRecord: '',
}

const contactState = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case FETCH_ALL_TENANT_CONTACTS:
      return {
        ...state,
        ...{
          allTenants: payload.allTenants,
        },
      }
    case FETCH_TENANT_CONTACTS:
      return {
        ...state,
        ...{
          tenants: payload.tenants,
          tanantsTotalRecord: payload.totalRecord,
        },
      }
    case SET_TENANT_PAGINATION:
      return {
        ...state,
        ...{
          tenantsPagination: {
            page: payload.page,
            sortColumn: payload.sortColumn,
            sortOrder: payload.sortOrder,
            search: payload.search,
            pageSize: payload.pageSize,
          },
        },
      }
    case FETCH_OWNER_CONTACTS:
      return {
        ...state,
        ...{
          owners: payload.owners,
          ownersTotalRecord: payload.totalRecord,
        },
      }
    case SET_OWNER_PAGINATION:
      return {
        ...state,
        ...{
          ownersPagination: {
            page: payload.page,
            sortColumn: payload.sortColumn,
            sortOrder: payload.sortOrder,
            search: payload.search,
            pageSize: payload.pageSize,
          },
        },
      }
    case UPDATE_TENANT_CONTACT:
      return {
        ...state,
        ...{
          tenants: state.tenants.map((tenant) => {
            // eslint-disable-line
            return tenant.id === payload.id ? payload : tenant
          }),
        },
      }
    case UPDATE_OWNER_CONTACT:
      return {
        ...state,
        ...{
          owners: state.owners.map((owner) => {
            // eslint-disable-line
            return owner.id === payload.id ? payload : owner
          }),
        },
      }
    default:
      return state
  }
}
export default contactState
